import styled from 'styled-components';
import { Col, Container } from 'reactstrap';

export const ContainerButton = styled.div`
    align-items: center;
    display: flex;
    gap: 20px;
    justify-content: center;
    width: 100%;
`;

export const ContainerStyled = styled(Container)`
    padding: 20px 30px 5px 30px;
`;

export const Placeholder = styled.span`
    color: ${ ({ theme: { primaryColor } }) => primaryColor };
    font-size: 15px;
    font-weight: normal;
    padding:10px;
`;

export const ContainerChat = styled(Col)`
    max-height: 200px;
`;
